
import React from "react";
import { Button } from "@/components/ui/button";

interface CourseSidebarProps {
  imageUrl: string | null;
  title: string;
  price: string;
  duration: string;
  isEnrolled: boolean;
  courseStatus: string;
  onEnroll: () => void;
  onGetNotified: () => void;
}

const CourseSidebar = ({
  imageUrl,
  title,
  price,
  duration,
  isEnrolled,
  courseStatus,
  onEnroll,
  onGetNotified
}: CourseSidebarProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6 sticky top-24">
      <div className="aspect-video bg-gray-100 rounded-md mb-4 overflow-hidden">
        <img 
          src={imageUrl || "/placeholder.svg"} 
          alt={title}
          title={title}
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="mb-4">
        <div className="text-3xl font-bold mb-1">{price}</div>
        <div className="text-sm text-gray-500">{duration}</div>
      </div>
      
      <Button 
        className="w-full mb-4" 
        variant="default"
        onClick={courseStatus === "Enrolling" ? onEnroll : onGetNotified}
      >
        {isEnrolled ? "Continue Learning" : (courseStatus === "Enrolling" ? "Enroll Now" : "Get Notified")}
      </Button>
    </div>
  );
};

export default CourseSidebar;
